module.exports = __webpack_public_path__ + "img/debate235.053769b4.jpg";